module.exports = __webpack_public_path__ + "fonts/nunito-v16-latin-regular.woff2";